import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { AddEditWarningPopupComponent } from './add-edit-warning-popup/add-edit-warning-popup.component';

@Component({
    selector: 'app-warning-panel',
    templateUrl: './warning-panel.component.html',
    styleUrls: ['./warning-panel.component.scss'],
    standalone: false
})
export class WarningPanelComponent implements OnInit {

  public EmployeeId: string;

  constructor(
    public employeeService: EmployeeService,
    private sharedService: SharedService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.EmployeeId = localStorage.getItem('EmplooyeeID');
  }

  public EditWarningText(): void{
    const dialogRef = this.dialog.open(AddEditWarningPopupComponent);
    dialogRef.componentInstance.EmployeeId = Number(this.EmployeeId);
  }

  public DeleteWarningText(): void {
    this.employeeService.DeleteEmployeeWarningText(this.EmployeeId).subscribe(res => {
      if (res.code === 0) {
        this.sharedService.ShowSnackBar('Se eliminó correctamente el aviso');
        this.employeeService.saveemplooye.emit(this.EmployeeId);
      } else {
        this.sharedService.ShowSnackBar('No se pudo borrar el aviso');
      }
    }, error => {
      this.sharedService.ShowSnackBar('No se pudo borrar el aviso');
      console.error(error);
    });
  }

}
